import React, { Component } from 'react';
import _ from 'lodash';
import ReactDataGrid from 'react-data-grid';
import { Data, Toolbar } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import { Row, Col, Panel, Button, ButtonToolbar } from 'react-bootstrap';
import PropTypes from 'prop-types';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import CheckboxFormatter from '../Common/CheckboxFormatter';
import SpinnerButton from '../Common/SpinnerButton';
import { isOLG } from '../../actions/root_url';

class MobileManagementTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sortColumn: null,
      sortDirection: null,
      filters: null,
      rows: props.rows,
      selectedRows: [],
      editedRows: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.rows && nextProps.rows !== this.props.rows) {
      this.setState({ rows: nextProps.rows });
    }
  }

  saveProducts = () => {
    const { saveProducts: { saveGreatDeals, saveNewArrivals } } = this.props;
    const { editedRows } = this.state;
    const greatDeals = [];
    const nonGreatDeals = [];
    const newArrivals = [];
    const nonNewArrivals = [];
    _.forEach(editedRows, (row) => {
      if (row.IsGreatDeal) {
        greatDeals.push(row.Product_id);
      } else {
        nonGreatDeals.push(row.Product_id);
      }
      if (row.IsNewArrival) {
        newArrivals.push(row.Product_id);
      } else {
        nonNewArrivals.push(row.Product_id);
      }
    });
    saveGreatDeals(greatDeals, true);
    saveGreatDeals(nonGreatDeals, false);
    saveNewArrivals(newArrivals, true);
    saveNewArrivals(nonNewArrivals, false);
  }

  renderTable() {
    if (this.props.rowsIsLoading) {
      return <Spinner />;
    }
    const getRows = () => Data.Selectors.getRows(this.state);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, { sortColumn, sortDirection });
      this.setState(state);
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      this.setState({ filters: newFilters });
    };

    const handleRowUpdated = (e) => {
      // merge updated row with current row and rerender by setting state
      this.setState({ sortColumn: null, sortDirection: null });
      const rows = getRows();
      const editedRows = this.state.editedRows.slice(0);
      Object.assign(rows[e.rowIdx], e.updated);
      // if the element is already edited, remove the old one.
      editedRows.forEach((element, index) => {
        if (element.Idx === rows[e.rowIdx].Idx) {
          editedRows.splice(index, 1);
        }
      }, this);
      // push the row into the editedRows array
      editedRows.push(rows[e.rowIdx]);
      this.setState({ rows, editedRows });
    };

    const handleIsEnabledClick = (isEnabled) => {
      const rows = getRows();
      const index = _.findIndex(rows, { Product_id: isEnabled.dependentValues.Product_id });
      rows[index][isEnabled.column.key] = !(rows[index][isEnabled.column.key]);
      const editedRows = [...this.state.editedRows];
      editedRows.map((row, idx) => {
        if (row.Product_id === rows[index].Product_id) {
          editedRows.splice(idx, 1);
        }
      });
      editedRows.push(rows[index]);
      this.setState({ rows, editedRows });
    };

    const columns = [
      {
        key: 'ProductNum',
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: 'RefNum',
        name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: 'Name',
        name: <Translate value="name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 250,
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 200,
      },
      {
        key: 'IsGreatDeal',
        name: <Translate value="great_deals" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
        formatter: <CheckboxFormatter handleOnClick={handleIsEnabledClick} />,
        getRowMetaData: row => row,
      },
      {
        key: 'IsNewArrival',
        name: <Translate value="new_arrivals" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
        formatter: <CheckboxFormatter handleOnClick={handleIsEnabledClick} />,
        getRowMetaData: row => row,
      },
    ];

    return (
      <Row>
        <Col sm={12}>
          <div>
            <ReactDataGrid
              columns={columns}
              enableCellSelect
              minHeight={620}
              onAddFilter={handleFilterChange}
              onGridSort={handleGridSort}
              onRowUpdated={handleRowUpdated}
              rowGetter={rowGetter}
              rowHeight={45}
              rowsCount={getSize()}
              toolbar={<Toolbar enableFilter />}
            />
          </div>
        </Col>
      </Row>
    );
  }

  render() {
    const shouldDisable = this.state.editedRows.length === 0;
    const { isUpdating } = this.props;
    return (
      <Panel id="mobile-management-detail">
        <ContentWrapper>
          {/* <h2>{this.props.title}</h2> */}
          <ButtonToolbar>
            <SpinnerButton
              className="save-button"
              bsStyle="success"
              disabled={shouldDisable || isUpdating}
              onClick={this.saveProducts}
              loading={isUpdating}
              icon="fa-save"
              translation={<Translate value="save" />}
            />
          </ButtonToolbar>
          {this.renderTable()}
        </ContentWrapper>
      </Panel>
    );
  }
}

MobileManagementTable.defaultProps = {
  rows: [],
  // title: '',
};

MobileManagementTable.propTypes = {
  rows: PropTypes.array,
  // title: PropTypes.string,
  rowsIsLoading: PropTypes.bool.isRequired,
  saveProducts: PropTypes.shape({
    saveGreatDeals: PropTypes.func,
    saveNewArrivals: PropTypes.func,
  }).isRequired,
  isUpdating: PropTypes.bool.isRequired,
};

export default MobileManagementTable;



// WEBPACK FOOTER //
// ./master/jsx/components/General/MobileManagementTable.jsx